import * as types from '../../../actions/types';
import createReducer from '../../../../utils/createReducer';
import { getFormatDate } from '../../../../helpers';

const initialSearchState = {
    search: {
        origin: '',
        originplace: '',
        destination: '',
        destinationplace: '',
        outbounddate: getFormatDate(new Date()),
        outbounddepartstarttime: '00:00',
        outbounddepartendtime: '23:59',
        inbounddate: '',
        inbounddepartstarttime: '00:00',
        inbounddepartendtime: '23:59',
        passengers: 1,
        adults: 1,
        children: 0,
        infants: 0,
        stops: '',
        //  specialdiscounts: 'NoDiscountedFares',
        specialdiscounts: '',
        alliances: [],
        includeCarriers: [],
        excludeCarriers: [],
        cabinclass: 'Economy',
        more_options: false,
        municipality: '',
        municipality_zip: '',
        errors: {},
        buttonEnabled: true
    },
    searcher: {
        show: false,
        locations: []
    },
    passengers: {
        show: false
    }
};

export const flightSearchReducer = createReducer(initialSearchState, {
    [types.UPDATE_FLIGHT_SEARCH](state, action) {
        const newSearch = Object.assign({}, state.search, action.search);
        return Object.assign({}, state, { search: newSearch });
    },
    [types.SET_FLIGHT_HISTORY](state, action) {
        return Object.assign({}, state, { queries: action.queries });
    },
    [types.SHOW_FLIGHT_HISTORY](state, action) {
        return Object.assign({}, state, { show_historic: action.show });
    },
    [types.SHOW_LOCATION_SEARCHER](state) {
        return Object.assign({}, state, { searcher: { show: !state.searcher.show, locations: [] } });
    },
    [types.SET_FLIGHT_LOCATIONS](state, action) {
        const newSearcher = Object.assign({}, state.searcher, { locations: action.locations });
        return Object.assign({}, state, { searcher: newSearcher });
    },
    [types.CLEAN_SEARCH](state) {
        return Object.assign({}, state, initialSearchState);
    },
    [types.UPDATE_FLIGHT_SEARCH_PASSENGERS](state, action) {
        // If we decrement and there are no passengers, return previous state
        if (state.search.passengers + action.numPassengers <= 0) return state;

        // If we decrement and there are less than 0 passengers from current type, return previous state
        if (state.search[action.passengerType] + action.numPassengers < 0) return state;

        // If we increment and there are more than 9 passengers in total, return previous state
        if (state.search.passengers + action.numPassengers > 9) return state;

        // Merge state passengers with new values 
        const passengers = Object.assign({},
            { passengers: (state.search.passengers + action.numPassengers) },
            { [action.passengerType]: state.search[action.passengerType] + action.numPassengers }
        );

        // Merge last state search with our new state properties
        const newSearchPassengers = Object.assign({}, state.search, passengers);

        return Object.assign({}, state, { search: newSearchPassengers });
    },
    [types.UPDATE_RESULT_SEARCH](state, action) {
        const newSearch = Object.assign({},
            state.search,
            {
                origin: action.search.origin,
                originplace: action.search.originplace || '',
                destination: action.search.destination || '',
                destinationplace: action.search.destinationplace || '',
                outbounddate:
                    action.search.outbounddate ?
                        action.search.outbounddate :
                        initialSearchState.search.outbounddate,
                outbounddepartstarttime:
                    action.search.outbounddepartstarttime ?
                        action.search.outbounddepartstarttime :
                        initialSearchState.search.outbounddepartstarttime,
                outbounddepartendtime:
                    action.search.outbounddepartendtime ?
                        action.search.outbounddepartendtime :
                        initialSearchState.search.outbounddepartendtime,
                inbounddate:
                    action.search.inbounddate ?
                        action.search.inbounddate :
                        initialSearchState.search.inbounddate,
                inbounddepartstarttime:
                    action.search.inbounddepartstarttime ?
                        action.search.inbounddepartstarttime :
                        initialSearchState.search.inbounddepartstarttime,
                inbounddepartendtime:
                    action.search.inbounddepartendtime ?
                        action.search.inbounddepartendtime :
                        initialSearchState.search.inbounddepartendtime,
                passengers: Number(action.search.passengers) || 1,
                adults: Number(action.search.adults) || 1,
                children: Number(action.search.children) || 0,
                infants: Number(action.search.infants) || 0,
                stops: Number(action.search.stops) || '',
                // specialdiscounts: action.search.specialdiscounts || 'NoDiscountedFares',
                specialdiscounts: action.search.specialdiscounts || '',
                alliances: action.search.alliances || [],
                includeCarriers: action.search.includeCarriers || [],
                excludeCarriers: action.search.excludeCarriers || [],
                more_options: false,
                municipality: action.search.municipality,
                municipality_zip: action.search.municipality_zip,
                cabinclass: action.search.cabinclass || 'Economy'
            }
        );

        return Object.assign({}, state, { search: newSearch });
    },
    [types.SHOW_PASSENGERS](state) {
        const newPassenger = Object.assign({}, state.passengers, { show: !state.passengers.show });
        return Object.assign({}, state, { passengers: newPassenger });
    },
    [types.ENABLE_SEARCH_BUTTON](state, action) {
        const newSearch = Object.assign({}, state.search, { buttonEnabled: action.enabled });
        return Object.assign({}, state, { search: newSearch });
    }
});